import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import { useNavigate } from "react-router-dom";

import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { useAuthHandling } from '../useAuthhandling';
import Allimagestyle from "../Blog/Allimage_style";
import Allimageselect from "../Blog/Allimageselect";
import Select from 'react-select';


function Projectedit() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();
  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/dashboard");
  }
  let { id } = useParams();

  const [service, setService] = useState([]);
  const [formerror, setError] = useState({});
  const [formerror1, setError1] = useState({});

  const [cust, setCust] = useState([]);
  const [useroption,setUseroption]=useState([]);
  const [selecteduser,setSelecteduser]=useState([]);

  const [prof, setProf] = useState([]);
  const [profoption, setProfoption] = useState([]);
  const [selectedprof, setSelectedprof] = useState([]);

  const [sdate, setSdate] = useState("");
  const [edate, setEdate] = useState("");
  const [images, setImage] = useState([]);
  const [newimage, setNewImage] = useState([]);
  const [oldimage, setOldImage] = useState([]);
  const [oldlist, setoldlist] = useState([]);

  const [selectedImageId, setSelectedImageId] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);


  const [remove, setRemovemage] = useState();

  const getprof = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/data/professionals-dropdown`,
      {
        method: "GET",
      }
    );

    const data1 = await res.json();
    const data = data1.data;
    if (res.status === 404 || !data) {
      toast.error("error!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      setProf(data);
    }
  };

  const getcust = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/get-customers-dropdown`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );

    if (res.status === 200) {
      const data1 = await res.json();
      const data = data1.data;
      setCust(data);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getcust();
    }
    else {
       
      toast.error("error!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/project/get-project/${id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200 ) {
      const data = await res.json();

      setService(data.data[0]);
      setImage(data.data[0].projectImageList);
      setOldImage(data.data[0].projectImageList);
      setSdate(moment(data.data[0].startDate).utc().format("YYYY-MM-DD"));
      setEdate(moment(data.data[0].endDate).utc().format("YYYY-MM-DD"));

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setService({ ...service, [name]: value });
  };

  const handleInputsdate = (e) => {
    console.log(e);
    value = e.target.value;
    setSdate(value);
  };
  const handleInputedate = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setEdate(value);
  };
  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setNewImage({ ...newimage, [name]: e.target.files });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.projectName) {
      errors.projectName = "Name is required!";
    }

    if (!values.projectStatus) {
      errors.projectStatus = "Status is required!";
    }
    if (!values.location) {
      errors.location = "Location is required!";
    }
    if (!selectedprof?.value) {
      errors.professional = "Professional is required!";
    }
    if (!selecteduser?.value) {
      errors.customer = "Customer is required!";
    }
    if (!values.startDate) {
      errors.startDate = "Start date is required!";
    }
    if (!values.endDate) {
      errors.endDate = "End date is required!";
    }
    if (selectedImageId.length===0) {
      if (values.projectImageList.length===0) {
        errors.projectImage = "Image is required!";
      } 
    
    } 
  
    return errors;
  };
  const validates = (values) => {
    const errors = {};
    if (values.projectImage) {
      for (var i = 0; i < values.projectImage.length; i++) {
        if (
          values.projectImage[i].type === "image/jpeg" ||
          values.projectImage[i].type === "image/jpg" ||
          values.projectImage[i].type === "image/png"
        ) {
          if (values.projectImage[i].size > 1024 * 1000) {
            errors.projectImage =
              "maximum file size 1 mb...please upload an image less than 1 mb";
          }
        } else {
          errors.projectImage = "Only support jpg, jpeg, png image!";
        }
      }
    }
    return errors;
  };
  const PostData = async (e) => {
    e.preventDefault();
    const { projectName, projectStatus, location } = service;
    const ress = validate(service);
    const resss = validates(newimage);
    setError(ress);
    setError1(resss);
    if (
      !ress.projectName &&
      !ress.projectStatus &&
      !ress.location &&
      !resss.projectImage
    ) {
      // const formData = new FormData();
      // formData.append("projectName", service.projectName);
      // formData.append("projectStatus", service.projectStatus);
      // formData.append("location", service.location);
      // formData.append("professional", service.professional);
      // formData.append("customer", service.customer);
      // formData.append("startDate", service.startDate);
      // formData.append("endDate", service.endDate);
      // for (var x = 0; x < newimage?.projectImage?.length; x++) {
      //   formData.append("projectImage", newimage.projectImage[x]);
      // }


      // if (oldlist?.length > 0) {
      //   for (var y = 0; y < oldlist?.length; y++) {
      //     formData.append(`removedImages[${y}]`, oldlist[y].projectImage);
      //   }
      // } else {
      //   formData.append("removedImages", []);
      // }


      const data = {
        projectName: service.projectName,
        projectStatus:service.projectStatus,
        project_images: selectedImageId.map((img) => img.id),
        location:  service.location,
        professional:selectedprof?.value,
        customer:selecteduser?.value,
        startDate:service.startDate,
        endDate: service.endDate,
        removedImages: oldlist?.length > 0 ? oldlist.map((item) => item.projectImage) : [],
      };
      
      axios
        .put(`${Config.apiurl}/api/v1/crm/project/update/${id}`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success("Sucessfully updated Project", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setTimeout(() => navigate("/dashboard"), 3000);
          } 
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else { 
            toast.error("something went wrong", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  };

  useEffect(() => {
    getinfo();
    getprof();
    getcust();
  }, []);
  // console.log("cust", cust);

  const removeImage = (id) => {
    // delete oldimage[id];
    oldlist.push(id);
    setImage((oldState) => oldState.filter((item) => item !== id));
    const res = oldimage.map((el1) => ({
      name: el1,
      match: images.some((el2) => el2 === el1),
    }));
    setRemovemage(res);
  };

  useEffect(()=>{
    const options = cust.map(item => ({ value: item?._id, label: item?.name }));
    setUseroption(options);
  },[cust])

  useEffect(()=>{
    const options = prof.map(item => ({ value: item?._id, label: item?.name }));
    setProfoption(options);
  },[prof])

  useEffect(()=>{
    const matched = useroption.find(opt => opt.value === service?.customer);
    setSelecteduser(matched || null);
  },[useroption,service.customer])

  useEffect(()=>{
    const matched = profoption.find(opt => opt.value === service?.professional);
    setSelectedprof(matched || null);
  },[profoption,service.professional])

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row grid-margin">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Project Edit Table</h4>
                    <form className="forms-sample" onSubmit={PostData}>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Project name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="projectName"
                          name="projectName"
                          value={service.projectName}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.projectName}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Status</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="projectStatus"
                          name="projectStatus"
                          value={service.projectStatus}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.projectStatus}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">location</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Location"
                          name="location"
                          value={service.location}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.location}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Professional
                        </label>
                          <Select             
                            options={profoption}
                            isSearchable={true}
                            className="my-select"
                            value={selectedprof}
                            onChange={setSelectedprof}
                            // placeholder="Select the number of bedrooms"
                            />
                        {/* <select
                          id="professional"
                          className="form-control"
                          name="professional"
                          onChange={handleInputs}
                          style={{ color: "black" }}
                          value={service.professional}
                        >
                        
                          {prof.map((element) => {
                            return (
                          
                              <option   value={element._id}
                              selected={service.professional === element._id ? "selected" : ""}
                              >
                                {element.name}
                              </option>
                           
                            );
                          })}
                        </select> */}
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">customer</label>
                        <Select 
                            options={useroption}
                            isSearchable={true}
                            value={selecteduser}
                            className="my-select"
                            onChange={setSelecteduser}
                            // placeholder="Select the number of bedrooms"
                            />
                        {/* <select
                          id="customer"
                          className="form-control"
                          name="customer"
                          onChange={handleInputs}
                          style={{ color: "black" }}
                          value={service.customer}
                        >
                         
                          {cust.map((elements) => {
                            return (
                             
                              <option
                              value={elements._id}
                              selected={service.customer === elements._id ? "selected" : ""}
                              >
                                {elements.name}
                              </option>
                             
                            );
                          })}
                        </select> */}
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Start Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="projectStatus"
                          name="startDate"
                          value={sdate}
                          onChange={handleInputsdate}
                          onClick={(e) => e.target.showPicker()}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="projectStatus"
                          name="endDate"
                          value={edate}
                          onChange={handleInputedate}
                          onClick={(e) => e.target.showPicker()}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          Image (500px * 343px)
                        </label>
                        <br></br>

                        <Allimagestyle selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>

                        {/* <input
                          type="file"
                          name="projectImage"
                          onChange={onFileChange}
                          multiple
                        /> */}
                        <div className="clear-fix"></div>
                        <div className="row" style={{marginRight:"0px",marginLeft: "0px",marginBottom:"12px"}}>
                        {images?.length !== 0
                          ? images?.map((elements, index) => {
                              return (
                                <div key={index}  className="position-relative col-md-2"
                                style={{
                                  width: "107px",
                                  height: "100px",
                                  marginTop: "5px",
                                  padding:"0px"
                                  //  marginRight: "5px",
                                }}
                                >
                                  <img
                                    src={elements.projectImage}
                                    alt=""
                                   
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      marginTop: "5px",
                                      marginLeft: "5px",
                                    }}
                                  />

                                  <button
                                    className=""
                                    type="button"
                                    onClick={(e) => removeImage(elements)}
                                    style={{
                                      position:"absolute",
                                      right:"0px",
                                      top:"5px"
                                    }}
                                  >
                                    X
                                  </button>
                                </div>
                              );
                            })
                          : ""}
                          </div>

                          <Allimageselect selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>

                        <label style={{ color: "red" }}>
                          {formerror1.projectImage}
                        </label>
                      </div>
                      <button
                        type="submit"
                        onClick={PostData}
                        className="btn btn-primary me-2"
                      >
                        Submit
                      </button>
                      <ToastContainer />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Projectedit;
